import MobileDetect from 'mobile-detect';

let md: MobileDetect | null = null;

export const getDeviceInfo = () => {
  if (!md) {
    md = new MobileDetect(window.navigator.userAgent);
  }

  const mobile = md.mobile();
  let tablet = md.tablet();
  const version = md.version('Webkit');
  const os = md.os();
  // iPad 인 경우 예외처리
  // https://stackoverflow.com/questions/56578799/tell-ipados-from-macos-on-the-web
  if (navigator.userAgent.match('Mac') && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
    tablet = 'iPad';
  }

  const isMobile = mobile !== null;
  const isTablet = tablet !== null;
  const isMobileOrTablet = isMobile || isTablet;

  return {
    md,
    mobile: mobile,
    tablet: tablet,
    webkitVersion: version,
    os: os,
    isMobileOrTablet: isMobileOrTablet,
  };
};
